export default __webpack_public_path__ + "static/media/sideMenu_bundle.d7d9c06e.svg";